import {denormFn, normFn} from '../normalizerSupport';
import * as Types from './types';

export const normalize = normFn<Types.PanelObjSchema>('panel', whole => whole);

export const denormalize = denormFn<Types.PanelObjSchema>(part => part);
